module.exports = "/images/icon-unmute.svg?40e740e3fd2d946e9559a8ef9be7ed63";